import { render, staticRenderFns } from "./MandatoryOrderRequirementsModal.vue?vue&type=template&id=4e82a856&scoped=true"
import script from "./MandatoryOrderRequirementsModal.vue?vue&type=script&lang=js"
export * from "./MandatoryOrderRequirementsModal.vue?vue&type=script&lang=js"
import style0 from "./MandatoryOrderRequirementsModal.vue?vue&type=style&index=0&id=4e82a856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e82a856",
  null
  
)

export default component.exports